import { render, staticRenderFns } from "./BaseGrowingCenteredArrow.vue?vue&type=template&id=abb887c0&"
import script from "./BaseGrowingCenteredArrow.vue?vue&type=script&lang=js&"
export * from "./BaseGrowingCenteredArrow.vue?vue&type=script&lang=js&"
import style0 from "./BaseGrowingCenteredArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports